export default __webpack_public_path__ + "static/media/sym.f6f2fba6.svg";